export default {
	nullOption() {
		return { routingNumber: "", bankName: "", displayName: "" }
	},

	accountTypes: ["Checking", "Savings"]
}
